import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritDriverInfoQueryParamsType,
  GetCulpritDriverInfoQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQuery.type';

export const getCulpritDriverInfoFunction = (
  params: GetCulpritDriverInfoQueryParamsType,
): Promise<GetCulpritDriverInfoQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params?.id}/accident_users/culprit/user_information/driver/`,
  );
};
